import React from "react";

/** Crawler-friendly FAQ + use-case index (visually hidden, readable in HTML source). */
export default function DomainHiddenSeoContent({ domainTitle, domainFaqs = [], useCases = [] }) {
  if (!domainFaqs.length && !useCases.length) return null;

  return (
    <section
      className="sr-only"
      aria-label={`${domainTitle} SEO and LLM reference content`}
    >
      <h2>{domainTitle} — use case reference</h2>
      <p>
        Machine-readable index for search engines and LLM crawlers. Each entry includes
        challenge, solution, automation type, systems, regions, and canonical URL.
      </p>

      {useCases.map((uc) => (
        <article key={uc.id} id={`seo-${uc.id}`} itemScope itemType="https://schema.org/TechArticle">
          <h3 itemProp="headline">{uc.seoHeadline || uc.title}</h3>
          {uc.canonicalUrl ? <link itemProp="url" href={uc.canonicalUrl} /> : null}
          {uc.businessProcess ? (
            <p>
              <strong>Business process:</strong> <span itemProp="name">{uc.businessProcess}</span>
            </p>
          ) : null}
          <p>
            <strong>Category:</strong> <span itemProp="articleSection">{uc.subIndustry}</span>
          </p>
          {uc.department ? <p><strong>Department:</strong> {uc.department}</p> : null}
          {uc.automationType ? (
            <p>
              <strong>Automation type:</strong> <span itemProp="genre">{uc.automationType}</span>
            </p>
          ) : null}
          <p itemProp="description">
            <strong>Challenge:</strong> {uc.challenge}
          </p>
          <p itemProp="text">
            <strong>Solution:</strong> {uc.solution}
          </p>
          {uc.seoSummary ? <p><strong>Summary:</strong> {uc.seoSummary}</p> : null}
          {uc.seoKeywords ? <meta itemProp="keywords" content={uc.seoKeywords} /> : null}
          {uc.regions ? <p><strong>Regions:</strong> {uc.regions}</p> : null}
          {uc.systems ? <p><strong>Systems:</strong> {uc.systems}</p> : null}
          {uc.agentsRequired ? <p><strong>Agents:</strong> {uc.agentsRequired}</p> : null}
          {uc.keyBenefits ? <p><strong>Key benefits:</strong> {uc.keyBenefits}</p> : null}
          {uc.buyerPersona ? <p><strong>Buyer persona:</strong> {uc.buyerPersona}</p> : null}
          {uc.faqs?.length ? (
            <section aria-label={`${uc.title} FAQs`}>
              {uc.faqs.map((faq, i) => (
                <div key={i}>
                  <h4>{faq.question}</h4>
                  <p>{faq.answer}</p>
                </div>
              ))}
            </section>
          ) : null}
        </article>
      ))}

      {domainFaqs.length ? (
        <section aria-label="Frequently asked questions">
          <h2>{domainTitle} FAQs</h2>
          {domainFaqs.map((faq, i) => (
            <div key={i}>
              <h3>{faq.question}</h3>
              <p>{faq.answer}</p>
            </div>
          ))}
        </section>
      ) : null}
    </section>
  );
}

